import React from "react";

const FilterIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6693 1H1.33594L6.66927 7.30667V11.6667L9.33594 13V7.30667L14.6693 1Z"
        stroke="#9CA3AF"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
